import { useEffect, useState } from 'react';
import _ from 'lodash';
import { Box, makeStyles, ButtonBase } from '@material-ui/core';
import Dialog from '../../../../../components/Dialog';
import TitleBox from '../../TitleBox.js';
import { AutoCompleteSelect } from '../../../../../components';
import { AddIcon, FemaleIcon, MaleIcon, OccupiedIcon, XmaleIcon } from '../../../../../components/Icon';
import { Checkbox } from '../../../../DutyAssign/components/Attendance/Setting';
import Text from '../../../../../components/Text';
import { eadmissionAPI } from '../../../../../apis';
import { ReactComponent as AddBedIcon } from '../../../../../static/images/AddBedIcon.svg';
import StyleInput from '../../../../../components/StyleInput/index.js';

const useStyles = makeStyles((theme) => ({
  border: {
    maxWidth: '1px',
    backgroundColor: '#E4E7EB',
    flex: '1',
  },
  AddIcon: {
    fontSize: '1rem',
    color: '#538FFF',
  },
  addBtn: {
    fontSize: '1rem',
    color: '#538FFF',
    fontFamily: 'NotoSans-Bold',
    gap: '0.38rem',
  },
  maleIcon: {
    fontSize: '1rem',
    color: '#538FFF',
  },
  femaleIcon: {
    fontSize: '1.125rem',
    color: '#FF8181',
  },
  xmaleIcon: {
    fontSize: '1.5rem',
    color: '#7B80FF',
  },
  addBedIcon: {
    height: '3.125rem',
  },
  addIcon1: {
    fontSize: '0.75rem',
    color: '#FFF',
  },
  OccupiedIcon: {
    fontSize: '1.2rem',
    color: '#FFF',
  },
}));

const WardAssignmentFilter = ({
  close,
  handleClose,
  handleConfirm,
  defGender,
  defSpec,
  filterInfo,
  defSubSpec,
  defaultIsolationRoom,
}) => {
  const classes = useStyles();
  const [form, setForm] = useState({
    specialty: defSpec,
    wardLocationStatus: '',
    wardLocationRemark: '',
    cubicleType: '',
    excludingAddedBed: false,
    cubicle: [],
    gender: [...defGender],
    show: false,
    wardLocStatus: [],
    wardLocRemark: [],
    cubicleTypeArr: [],
    subSpecialtyCode: defSubSpec,
    isoRooms: [...defaultIsolationRoom],
    isMatchedAge: false,
  });
  const [isoList, setIsoList] = useState([]);

  const getIsoRoomList = async () => {
    try {
      const { result } = await eadmissionAPI.getIsolationRoomList();
      setIsoList(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getIsoRoomList();
  }, []);

  const changForm = () => {
    setForm((o) => ({
      ...o,
      specialty: filterInfo.filter.specialtyCode,
      subSpecialtyCode: filterInfo.filter.subSpecialtyCode,
      wardLocStatus:
        filterInfo.filter.status.length === 0
          ? [{ value: '', id: 1 }]
          : filterInfo.filter.status.map((value, index) => {
              return { value: value, id: index + 1 };
            }),
      wardLocRemark:
        filterInfo.filter.remark.length === 0
          ? [{ value: '', id: 1 }]
          : filterInfo.filter.remark.map((value, index) => {
              return { value: value, id: index + 1 };
            }),
      cubicleTypeArr:
        filterInfo.filter.cubicleType.length === 0
          ? [{ value: '', id: 1 }]
          : filterInfo.filter.cubicleType.map((value, index) => {
              return { value: value, id: index + 1 };
            }),
      excludingAddedBed: filterInfo.filter.isExcludingAddedbed,
      cubicle: filterInfo.filter.cubicleGender,
      show: filterInfo.filter.isLessthanThreshold,
      gender: filterInfo.filter.gender,
      isoRooms: filterInfo.filter.isoRooms,
      isMatchedAge: filterInfo.filter.isMatchedAge === 1,
    }));
  };
  useEffect(() => {
    changForm();
  }, [filterInfo]);
  const filterStatus = () => {
    return StatusList.filter((item1) => !form.wardLocStatus.some((item2) => item1['value'] === item2['value']));
  };

  const filterCubicleType = () => {
    return cubicleTypeList.filter((item1) => !form.cubicleTypeArr.some((item2) => item1['value'] === item2['value']));
  };

  const [initForm] = useState({
    specialty: null,
    wardLocationStatus: '',
    wardLocationRemark: '',
    cubicleType: '',
    excludingAddedBed: false,
    cubicle: [],
    gender: [],
    show: false,
    wardLocStatus: [],
    wardLocRemark: [],
    cubicleTypeArr: [],
    subSpecialtyCode: null,
    isoRooms: [],
    isMatchedAge: 0,
  });
  const StatusList = [
    {
      text: 'Disinfection',
      value: 'Disinfection',
    },
    {
      text: 'Frozen',
      value: 'Frozen',
    },
    {
      text: 'In-use',
      value: 'In-use',
    },
    {
      text: 'Maintenance',
      value: 'Maintenance',
    },
    {
      text: 'Overhaul',
      value: 'Overhaul',
    },
  ];
  const cubicleTypeList = [
    {
      text: 'AIIR',
      value: 'AIIR',
    },
    {
      text: 'Airborne Isolation',
      value: 'Airborne Isolation',
    },
    {
      text: 'Clean',
      value: 'Clean',
    },
    {
      text: 'Contact Isolation',
      value: 'Contact Isolation',
    },
    {
      text: 'CPE',
      value: 'CPE',
    },
    {
      text: 'Droplet Isolation',
      value: 'Droplet Isolation',
    },
    {
      text: 'EOL',
      value: 'EOL',
    },
    {
      text: 'HFOT',
      value: 'HFOT',
    },
    {
      text: 'ICEC',
      value: 'ICEC',
    },
    {
      text: 'Isolation',
      value: 'Isolation',
    },
    {
      text: 'MDROs',
      value: 'MDROs',
    },
    {
      text: 'MRSA Cohort',
      value: 'MRSA Cohort',
    },
    {
      text: 'NIV',
      value: 'NIV',
    },
    {
      text: 'Protective Isolation',
      value: 'Protective Isolation',
    },
    {
      text: 'Reverse Isolation',
      value: 'Reverse Isolation',
    },
    {
      text: 'Single Room',
      value: 'Single Room',
    },
    {
      text: 'Surveillance Cubicle',
      value: 'Surveillance Cubicle',
    },
    {
      text: 'Surveillance Room',
      value: 'Surveillance Room',
    },
    {
      text: 'Uni-dir. Flow Room',
      value: 'Uni-dir. Flow Room',
    },
    {
      text: 'VRE',
      value: 'VRE',
    },
  ];
  const [hospSpecList, setHospSpecList] = useState();
  const [specState, setSpecState] = useState({
    subSpecialtyCode: filterInfo.filter.subSpecialtyCode,
    specialtyCode: filterInfo.filter.specialtyCode,
  });
  const getHospSpecList = async () => {
    try {
      const { result } = await eadmissionAPI.getHospSpec();
      const list = result.map((item) => {
        return {
          text: `${item.specialtyCode}   ${item.subSpecialtyCode === null ? '' : item.subSpecialtyCode}`,
          value: item,
        };
      });
      const lists = [{ text: '', value: { subSpecialtyCode: null, specialtyCode: null } }].concat(list);
      setHospSpecList(lists);
    } catch (err) {}
  };
  useEffect(() => {
    getHospSpecList();
  }, []);

  const addCubicleData = (newData) => {
    setForm((prevForm) => ({
      ...prevForm,
      cubicle: [...prevForm.cubicle, newData],
    }));
  }; // add cubicle data
  const removeCubicleData = (dataToRemove) => {
    setForm((prevForm) => ({
      ...prevForm,
      cubicle: prevForm.cubicle.filter((data) => data !== dataToRemove),
    }));
  }; // remove cubicle data
  const addGenderData = (newData) => {
    setForm((prevForm) => ({
      ...prevForm,
      gender: [...prevForm.gender, newData],
    }));
  }; // add gender data
  const removeGenderData = (dataToRemove) => {
    setForm((prevForm) => ({
      ...prevForm,
      gender: prevForm.gender.filter((data) => data !== dataToRemove),
    }));
  }; // remove gender data

  const handleAddWardLocStatus = () => {
    setForm((o) => ({
      ...o,
      wardLocStatus: [...o.wardLocStatus, { value: '', id: o.wardLocStatus[o.wardLocStatus.length - 1].id + 1 }],
    }));
  };

  const handleAddWardLocRemark = () => {
    setForm((o) => ({
      ...o,
      wardLocRemark: [...o.wardLocRemark, { value: '', id: o.wardLocRemark[o.wardLocRemark.length - 1].id + 1 }],
    }));
  };
  const handleAddCubicleType = () => {
    setForm((o) => ({
      ...o,
      cubicleTypeArr: [...o.cubicleTypeArr, { value: '', id: o.cubicleTypeArr[o.cubicleTypeArr.length - 1].id + 1 }],
    }));
  };

  const updateWardLocRemark = (e, id) => {
    setForm((preData) => ({
      ...preData,
      wardLocRemark: _.map(preData.wardLocRemark, (item) => ({
        ...item,
        value: item.id === id ? e : item.value,
      })),
    }));
  };

  const updateCubicleTypeArr = (e, id) => {
    setForm((preData) => ({
      ...preData,
      cubicleTypeArr: _.map(preData.cubicleTypeArr, (item) => ({
        ...item,
        value: item.id === id ? e : item.value,
      })),
    }));
  };

  const updateWardLocStatus = (e, id) => {
    setForm((preData) => ({
      ...preData,
      wardLocStatus: _.map(preData.wardLocStatus, (item) => ({
        ...item,
        value: item.id === id ? e : item.value,
      })),
    }));
  };

  const handleUpdateFilter =
    ({ type, id }) =>
    (e) => {
      switch (type) {
        case 'isMatchedAge':
          setForm((preData) => ({ ...preData, isMatchedAge: !preData?.isMatchedAge }));
          break;
        case 'specialty':
          // 用户改变specialty后，年龄匹配选项会取消勾选。
          setForm((preData) => ({
            ...preData,
            specialty: e.specialtyCode,
            subSpecialtyCode: e.subSpecialtyCode,
            isMatchedAge: false,
          }));
          setSpecState(e.specialtyCode || e.subSpecialtyCode ? e : '');
          break;
        case 'wardLocationStatus':
          updateWardLocStatus(e, id);
          break;
        case 'wardLocationRemark':
          updateWardLocRemark(e, id);
          break;
        case 'cubicleType':
          updateCubicleTypeArr(e, id);
          break;
        case 'cubicleMale':
          form.cubicle.includes('M') ? removeCubicleData('M') : addCubicleData('M');
          break;
        case 'cubicleFemale':
          form.cubicle.includes('F') ? removeCubicleData('F') : addCubicleData('F');
          break;
        case 'cubicleXmale':
          form.cubicle.includes('X') ? removeCubicleData('X') : addCubicleData('X');
          break;
        case 'excludingAddedBed':
          setForm((preData) => ({ ...preData, [type]: !preData[type] }));
          break;
        case 'show':
          setForm((preData) => ({ ...preData, [type]: !preData[type] }));
          break;
        case 'genderMale':
          form.gender.includes('M') ? removeGenderData('M') : addGenderData('M');
          break;
        case 'genderFemale':
          form.gender.includes('F') ? removeGenderData('F') : addGenderData('F');
          break;
        case 'genderXmale':
          form.gender.includes('X') ? removeGenderData('X') : addGenderData('X');
          break;
        case 'Isolation':
          setForm((preData) => ({
            ...preData,
            isoRooms: _.some(preData.isoRooms, (item) => item === e)
              ? _.filter(preData.isoRooms, (item) => item !== e)
              : [...preData.isoRooms, e],
          }));
          break;
        default:
          break;
      }
    };
  return (
    <Dialog
      title="Filter"
      cancel="Reset"
      confirm="Confirm"
      width="63rem"
      open={close}
      handleClose={handleClose}
      handleCancel={() => {
        handleConfirm(initForm);
      }}
      handleConfirm={() => handleConfirm(form)}
      dialogfootStyle={{ boxShadow: '0px -1px 0px 0px #E4E7EB', paddingTop: '1rem', marginTop: '1.25rem' }}
      dialogRootStyle={{ paddingBottom: '1rem' }}
    >
      <Box display="flex" gridGap="2.5rem">
        <Box display="flex" flexDirection="column" gridGap="1.88rem" width="34rem">
          <TitleBox title="Specialty">
            <AutoCompleteSelect
              itemList={hospSpecList}
              value={specState ?? ''}
              onChange={handleUpdateFilter({ type: 'specialty' })}
            />
          </TitleBox>
          <TitleBox title="Ward Location Status">
            <Box display="flex" gridGap="0.75rem">
              {/* <AutoCompleteSelect width="10.6875rem" /> */}
              <Box display="flex" flexDirection="column" alignItems="start" gridGap="0.63rem" flex="1">
                {form.wardLocStatus.map((item) => (
                  <AutoCompleteSelect
                    itemList={StatusList}
                    key={item.id}
                    style={{ width: '100%' }}
                    value={item.value}
                    onChange={handleUpdateFilter({ type: 'wardLocationStatus', id: item.id })}
                    filterOptions={filterStatus}
                  />
                ))}
                <ButtonBase className={classes.addBtn} onClick={handleAddWardLocStatus}>
                  <AddIcon className={classes.AddIcon} /> Add
                </ButtonBase>
              </Box>
            </Box>
          </TitleBox>
          <TitleBox title="Ward Location Remark">
            <Box display="flex" gridGap="0.75rem">
              {/* <AutoCompleteSelect width="10.6875rem" /> */}
              <Box display="flex" flexDirection="column" alignItems="start" gridGap="0.63rem" flex="1">
                {form.wardLocRemark.map((item) => (
                  <StyleInput
                    key={item.id}
                    width="100%"
                    value={item.value}
                    onChange={handleUpdateFilter({ type: 'wardLocationRemark', id: item.id })}
                  />
                ))}
                <ButtonBase className={classes.addBtn} onClick={handleAddWardLocRemark}>
                  <AddIcon className={classes.AddIcon} /> Add
                </ButtonBase>
              </Box>
            </Box>
          </TitleBox>
          <TitleBox title="With Available Bed In Cubicle">
            <Box display="flex" flexDirection="column" gridGap="0.44rem">
              <Box display="flex" justifyContent="space-between">
                <Box display="flex" alignItems="center" gridGap="0.37rem">
                  <Checkbox
                    handleChange={handleUpdateFilter({ type: 'cubicleMale' })}
                    check={form.cubicle.includes('M')}
                  />
                  <Box display="flex" alignItems="center" justifyContent="center" width="1.5rem" height="1.5rem">
                    <MaleIcon className={classes.maleIcon} />
                  </Box>
                </Box>
                <Box display="flex" alignItems="center" gridGap="0.37rem">
                  <Checkbox
                    handleChange={handleUpdateFilter({ type: 'cubicleFemale' })}
                    check={form.cubicle.includes('F')}
                  />
                  <Box display="flex" alignItems="center" justifyContent="center" width="1.5rem" height="1.5rem">
                    <FemaleIcon className={classes.femaleIcon} />
                  </Box>
                </Box>
                <Box display="flex" alignItems="center" gridGap="0.37rem">
                  <Checkbox
                    handleChange={handleUpdateFilter({ type: 'cubicleXmale' })}
                    check={form.cubicle.includes('X')}
                  />
                  <Box display="flex" alignItems="center" justifyContent="center" width="1.5rem" height="1.5rem">
                    <XmaleIcon className={classes.xmaleIcon} />
                  </Box>
                </Box>
                <Box display="flex" alignItems="center" gridGap="0.37rem">
                  <Checkbox
                    handleChange={handleUpdateFilter({ type: 'excludingAddedBed' })}
                    check={form.excludingAddedBed}
                  />
                  <Text color="#7D86A9" fontSize="1rem">
                    Excluding added bed
                  </Text>
                  <Box display="flex">
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius="50%"
                      bgcolor="#73D5DD"
                      width="1.25rem"
                      height="1.25rem"
                    >
                      <AddIcon className={classes.addIcon1} />
                    </Box>
                    <AddBedIcon className={classes.addBedIcon} />
                  </Box>
                </Box>
              </Box>
              {form.cubicleTypeArr.map((item) => (
                <AutoCompleteSelect
                  itemList={cubicleTypeList}
                  key={item.id}
                  value={item.value}
                  onChange={handleUpdateFilter({ type: 'cubicleType', id: item.id })}
                  filterOptions={filterCubicleType}
                />
              ))}
              <ButtonBase className={classes.addBtn} style={{ width: '3rem' }} onClick={handleAddCubicleType}>
                <AddIcon className={classes.AddIcon} />
                Add
              </ButtonBase>
            </Box>
          </TitleBox>
        </Box>
        <div className={classes.border} />
        <Box display="flex" flexDirection="column" gridGap="2.5rem">
          {/* <Box display="flex" alignItems="center" gridGap="0.63rem">
            <Checkbox handleChange={handleUpdateFilter({ type: 'show' })} check={form.show} />
            <Text fontSize="1rem">Show</Text>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              width="1.875rem"
              height="1.875rem"
              borderRadius="5px"
              bgcolor="#FF655C"
              pl="0.2rem"
            >
              <OccupiedIcon className={classes.OccupiedIcon} />
            </Box>
            <Text fontSize="1rem">{`< threshold only`}</Text>
          </Box> */}
          <TitleBox title="Ward's Gender" display="flex" gridGap="1.62rem">
            <Box display="flex" gridGap="1.88rem">
              <Box display="flex" alignItems="center" gridGap="0.37rem">
                <Checkbox handleChange={handleUpdateFilter({ type: 'genderMale' })} check={form.gender.includes('M')} />
                <Box display="flex" alignItems="center" justifyContent="center" width="1.5rem" height="1.5rem">
                  <MaleIcon className={classes.maleIcon} />
                </Box>
              </Box>
              <Box display="flex" alignItems="center" gridGap="0.37rem">
                <Checkbox
                  handleChange={handleUpdateFilter({ type: 'genderFemale' })}
                  check={form.gender.includes('F')}
                />
                <Box display="flex" alignItems="center" justifyContent="center" width="1.5rem" height="1.5rem">
                  <FemaleIcon className={classes.femaleIcon} />
                </Box>
              </Box>
              <Box display="flex" alignItems="center" gridGap="0.37rem">
                <Checkbox
                  handleChange={handleUpdateFilter({ type: 'genderXmale' })}
                  check={form.gender.includes('X')}
                />
                <Box display="flex" alignItems="center" justifyContent="center" width="1.5rem" height="1.5rem">
                  <XmaleIcon className={classes.xmaleIcon} />
                </Box>
              </Box>
            </Box>
            <Box display="flex" gridGap="0.37rem" mt="1rem">
              <Checkbox handleChange={handleUpdateFilter({ type: 'isMatchedAge' })} check={form?.isMatchedAge} />
              <Text color="#2E4469" fontSize="1rem">
                {`Show matched patient\'s age ward only`}
              </Text>
            </Box>
          </TitleBox>
          <TitleBox title="Isolation" gridGap="1.62rem">
            <Box display="flex" flexDirection="column" gridGap="1rem">
              {isoList.map((item) => (
                <Box display="flex" alignItems="center" gridGap="0.5rem" key={item.codeValue}>
                  <Checkbox
                    handleChange={() => handleUpdateFilter({ type: 'Isolation' })(item.codeValue)}
                    check={form?.isoRooms?.includes?.(item.codeValue)}
                  />
                  <Text>{item.codeDesc}</Text>
                </Box>
              ))}
            </Box>
          </TitleBox>
        </Box>
      </Box>
    </Dialog>
  );
};

export default WardAssignmentFilter;
